// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__Xe22f","wrapper":"Intro_wrapper__+C-ze","title":"Intro_title__AWKBj","desc":"Intro_desc__GYQPT"};